import { ApiErrorSchema, type HqErrorCode } from "@bube-hq/contracts/errors";
import { translate } from "../../i18n/index.js";

/**
 * Lỗi từ API, đã bóc vỏ.
 *
 * Giao diện phân nhánh theo `code` — KHÔNG theo `message`. Câu chữ tiếng Việt là để người đọc; một
 * ngày ai đó sửa nó cho dễ hiểu hơn và một nhánh xử lý vỡ mà không có gì báo.
 */
export class HqApiError extends Error {
  readonly code: HqErrorCode;
  readonly status: number;
  readonly requestId: string;
  /** `error.details` của vỏ lỗi (hình dạng theo từng lỗi, vd `{ currentRevision }` của 409 khoá lạc quan) — đọc có kiểm. */
  readonly details: unknown;

  constructor(code: HqErrorCode, message: string, status: number, requestId: string, details?: unknown) {
    super(message);
    this.name = "HqApiError";
    this.code = code;
    this.status = status;
    this.requestId = requestId;
    this.details = details;
  }
}

/** Mạng hỏng khác hẳn máy chủ từ chối — gộp hai thứ thì người dùng không biết nên thử lại hay không. */
export class NetworkError extends Error {
  constructor(cause: unknown) {
    super(translate("common", "networkError"));
    this.name = "NetworkError";
    this.cause = cause;
  }
}

export async function toHqError(response: Response): Promise<HqApiError> {
  let body: unknown;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  const parsed = ApiErrorSchema.safeParse(body);
  if (parsed.success) {
    const { code, message, requestId, details } = parsed.data.error;
    return new HqApiError(code, message, response.status, requestId, details);
  }
  // Máy chủ trả một hình dạng không phải vỏ lỗi của hub — proxy, cân bằng tải, hoặc một tầng nào
  // khác. Nói đúng điều đó thay vì giả vờ đọc được.
  return new HqApiError(
    "HQ_INTERNAL",
    translate("common", "unexpectedErrorShape", { status: response.status }),
    response.status,
    "",
  );
}
